import _ from 'underscore';
import $ from 'jquery';
import View from 'view/base';
import Modal from 'root/module/modal';
import Form from 'root/module/form';
import Cache from 'root/cache';
import Modals from 'root/modals';

export default View.extend({
    events: {
        'click .view-info'                           : 'onClickViewInfo',
        'change input[name="has_close_button"]'      : 'updateSettings',
        'change input[name="has_required_indicator"]': 'updateSettings',
        'change input[name="has_page_number"]'       : 'updateSettings',
        'change input[name="has_captcha"]'           : 'updateSettings',
        'input input.button-text'                    : 'updateSettings',
        'click .account-upgrade'                     : 'onAccountUpgrade'
    },

    dom_handlers: {
        onAccountUpgrade: function () {
            Modals.choosePlan();
        },

        onClickViewInfo: function (e) {
            var name = $(e.currentTarget).data('name');

            // TODO: The improvement of the modal view will be part of Phase 2. Simply make it as an image in Phase 1.
            var settings = {
                close_button: {
                    title: 'Close Button',
                    img: '/image/survey_close_button.png',
                    text:'The close button allows respondents to leave the survey without submitting the form at any time.'
                },
                required_indicator: {
                    title: 'Required Indicator',
                    img: '/image/survey_required_indicator.png',
                    text:'Respondents must answer the required questions to proceed with or without the indicator.'
                },
                page_number: {
                    title: 'Page Number',
                    img: '/image/survey_page_number.png',
                    text:'‘Paged’ format only. The page number helps respondents to see the progress.'
                },
                captcha: {
                    title: 'Captcha',
                    img: '/image/survey_captcha.png',
                    text:'If enabled, will utilize hCaptcha to prevent spam submissions.'
                }
            };

            Modal.open({
                title: settings[name].title,
                content: '<img class="view-info-img" src="' + settings[name].img + '">' +
                         '<div class="view-info-text margin-top-20">'+ settings[name].text +'</div>',
                button_class: 'tertiary small',
                button: {
                    Close: () => {
                        Modal.close();
                    }
                }
            });
        },
        updateSettings: function (e) {
            this.updateSettings();
        }
    },

    getSettings: function () {
        const form_data = Form.getData(this.$el);
        const data = {
            has_close_button: !!form_data.has_close_button,
            has_required_indicator: !!form_data.has_required_indicator,
            has_page_number: !!form_data.has_page_number,
            has_captcha: !!form_data.has_captcha,
            system_text: JSON.stringify({
                submit: form_data.submit_button,
                next: form_data.next_button,
                back: form_data.back_button
            })
        };

        return data;
    },

    updateSettings: function () {
        const settings = this.getSettings();
        this.model.set(settings);
    },

    render: function () {
        var content =
        '<div class="setting-title">View</div>' +
        '<div class="setting-subtitle">Close Button<span class="view-info text-icon" data-name="close_button"><i class="fa-solid fa-circle-info"></i></span></div>' +
        '<div>' +
            '<input type="radio" name="has_close_button" id="has_close_button_1" value="1">' +
            '<label for="has_close_button_1">Show</label>' +

            '<input type="radio" name="has_close_button" id="has_close_button_2" value="0">' +
            '<label for="has_close_button_2">Hide</label>' +
        '</div>' +
        '<div class="divider-30"></div>' +

        '<div class="setting-subtitle">Required Indicator<span class="view-info text-icon" data-name="required_indicator"><i class="fa-solid fa-circle-info"></i></span></div>' +
        '<div>' +
            '<input type="radio" name="has_required_indicator" id="has_required_indicator_1" value="1">' +
            '<label for="has_required_indicator_1">Show</label>' +

            '<input type="radio" name="has_required_indicator" id="has_required_indicator_2" value="0">' +
            '<label for="has_required_indicator_2">Hide</label>' +
        '</div>' +
        '<div class="divider-30"></div>' +

        '<div class="setting-subtitle">Page Number<span class="view-info text-icon" data-name="page_number"><i class="fa-solid fa-circle-info"></i></span></div>' +
        '<div>' +
            '<input type="radio" name="has_page_number" id="has_page_number_1" value="1">' +
            '<label for="has_page_number_1">Show</label>' +

            '<input type="radio" name="has_page_number" id="has_page_number_2" value="0">' +
            '<label for="has_page_number_2">Hide</label>' +
        '</div>' +

        '<hr class="medium">' +

        '<div class="setting-title">Button Text</div>' +
        '<div class="position-relative margin-bottom-8">' +
            '<div class="setting-subtitle">Submit</div>' +
            '<div class="half-field">' +
                '<input type="text" class="solid compact button-text" maxlength="20" name="submit_button" placeholder="Submit">' +
                '<div class="maxlength-help"></div>' +
            '</div>' +
        '</div>' +
        '<div class="position-relative margin-bottom-8">' +
            '<div class="setting-subtitle">Next</div>' +
            '<div class="half-field">' +
                '<input type="text" class="solid compact button-text" maxlength="20" name="next_button" placeholder="Next">' +
                '<div class="maxlength-help"></div>' +
            '</div>' +
        '</div>' +
        '<div class="position-relative margin-bottom-8">' +
            '<div class="setting-subtitle">Back</div>' +
            '<div class="half-field">' +
                '<input type="text" class="solid compact button-text" maxlength="20" name="back_button" placeholder="Back">' +
                '<div class="maxlength-help"></div>' +
            '</div>' +
        '</div>' +

        '<hr class="medium">' +

        '<div class="setting-title">Security</div>' +
        '<div class="setting-subtitle">Captcha<span class="view-info text-icon" data-name="captcha"><i class="fa-solid fa-circle-info"></i></span></div>' +
        '<div class="flex-start">' +
            '<input type="radio" name="has_captcha" id="has_captcha_1" value="1">' +
            '<label for="has_captcha_1">Show</label>' +

            '<input type="radio" name="has_captcha" id="has_captcha_2" value="0">' +
            '<label for="has_captcha_2">Hide</label>' +

            (Cache.account.hasFeature('hcaptcha') ? '' :
            '<button type="button" class="account-upgrade tiny shiny"><span>UPGRADE</span></button>') +
        '</div>';

        this.$el.html(content);

        if (!Cache.account.hasFeature('hcaptcha')) {
            this.$el.find('input[name="has_captcha"]').prop('disabled', true);
        }

        // read system text
        // check whether thats json format
        // if yes, parse it and set the value to the input
        // if no, set empty
        var system_text = this.model.get('system_text');
        if (system_text) {
            try {
                system_text = JSON.parse(system_text);
            } catch (e) {
                system_text = {};
            }
        } else {
            system_text = {};
        }

        Form.setData(this.$el, {
            has_close_button   : this.model.get('has_close_button'),
            has_required_indicator : this.model.get('has_required_indicator'),
            has_page_number : this.model.get('has_page_number'),
            has_captcha : this.model.get('has_captcha'),
            submit_button : system_text.submit || '',
            next_button : system_text.next || '',
            back_button : system_text.back || ''
        });

        return this;
    }
});
